import {YOUTUBE, VIMEO, WISTIA, VIDYARD} from "src/legacy/constants/fileTypes.jsx";

export default function (metadata) {
  if (metadata.content_type === "application/url") {
    if (metadata.external_video_provider) {
      if (metadata.external_video_provider === YOUTUBE) {
        return false;
      } else if (metadata.external_video_provider === VIMEO) {
        return false;
      } else if (metadata.external_video_provider === WISTIA) {
        return false;
      } else if (metadata.external_video_provider === VIDYARD) {
        return false;
      }
    }
    return true;
  }
  return false;
};
